import moment from 'moment-timezone';
import { useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { primaryShadow } from '@hivebrite/design-system/Theme';

export const Calendar = ({
  startDate,
  eventDisplayTimeZone = 'Europe/Paris',
}) => {
  const [day, month] = useMemo(() => {
    const mom = moment(startDate).tz(eventDisplayTimeZone);

    return [mom.date(), mom.format('MMM')];
  }, [startDate, eventDisplayTimeZone]);

  return (
    <time dateTime={startDate} role="time">
      <Wrapper>
        <Box font="h4-semibold" color="black">
          {day}
        </Box>
        <Box font="metadata-regular-asphalt" color="asphalt">
          {month}
        </Box>
      </Wrapper>
    </time>
  );
};

const Wrapper = styled(Box).attrs({
  alignItems: 'center',
  alignSelf: 'flex-start',
  flexDirection: 'column',
  justifyContent: 'space-around',
  minWidth: '40px',
  fontWeight: 1,
  flexShrink: 0,
  backgroundColor: 'white',
  p: 1,
})`
  border-radius: 4px;
  ${primaryShadow}
`;
